import React, { createContext, useContext, useState, type ReactNode } from 'react';

interface FullscreenContextState {
  isFullscreenDialogOpen: boolean;
  setIsFullscreenDialogOpen: (open: boolean) => void;
}

const FullscreenContext = createContext<FullscreenContextState>({
  isFullscreenDialogOpen: false,
  setIsFullscreenDialogOpen: () => {},
});

export const useFullscreenDialogOpen = (selector: (state: FullscreenContextState) => unknown) => {
  const context = useContext(FullscreenContext);
  return selector(context);
};

export const FullscreenProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isFullscreenDialogOpen, setIsFullscreenDialogOpen] = useState<boolean>(false);

  const contextValue: FullscreenContextState = {
    isFullscreenDialogOpen,
    setIsFullscreenDialogOpen,
  };

  return (
    <FullscreenContext.Provider value={contextValue}>
      {children}
    </FullscreenContext.Provider>
  );
};

export default FullscreenContext;